import { createContext, useContext } from "react";

import { useAppToken } from "../hooks/api/useAppToken";
import { GraphQlClientProvider } from "./GraphQlClientProvider";

const AppTokenContext = createContext<string>("");

export function AppTokenProvider({ children }: { children: React.ReactNode }) {
  const { data } = useAppToken();

  const token = data || ""; // we are using react suspense and error boundaries, so data should always be defined when this component is rendered
  // Derive the authed GraphQL client from the same token so every consumer below shares one
  // instance (no module-level client to mutate). Nesting it here means all three mount trees
  // (SPA, legacy per-page, admin) and the test wrapper get it for free.
  return (
    <AppTokenContext.Provider value={token}>
      <GraphQlClientProvider token={token}>{children}</GraphQlClientProvider>
    </AppTokenContext.Provider>
  );
}

export function useProvidedAppToken() {
  const ctx = useContext(AppTokenContext);
  if (ctx === undefined) {
    throw new Error("useProvidedAppToken must be used within AppTokenProvider");
  }
  return ctx;
}
